import { Actions, OnInitEffects, createEffect, ofType, rootEffectsInit } from "@ngrx/effects";
import * as userActions from './user.actions';
import { catchError, filter, map, mergeMap, withLatestFrom, tap } from "rxjs/operators";
import { UserAccessPermissionService } from "src/app/core/services/userAccessPermission/user-access-permission.service";
import { of } from "rxjs";
import { Action, Store } from "@ngrx/store";
import { Users } from "src/app/data/models";
import { RespondUser } from "src/app/data/models/respond/respond.model";
import { Injectable } from "@angular/core";
import * as featureActions from '../../state/features/feature.actions';
import * as featureSelectors from '../../state/features/feature.selectors';
import * as userSelectors from './user.selectors';

@Injectable()
export class UserEffects implements OnInitEffects {
    constructor(private action$: Actions, private permissionService: UserAccessPermissionService, private store: Store) { }
    ngrxOnInitEffects(): Action {
        const storageUser = localStorage.getItem('currentuser');
        if (storageUser) {
            const user = JSON.parse(storageUser) as Users;
            return userActions.userLoggedIn({ user });
        }
        const storageRespond = localStorage.getItem('responduser');
        if (storageRespond) {
            const user = JSON.parse(storageRespond) as RespondUser;
            return userActions.userLoggedIn({ respondUser: user });
        }
        return userActions.userLoggedOut();
    }

    loggedIn$ = createEffect(() => this.action$.pipe(
        ofType(userActions.userLoggedIn),
        tap(({ user, respondUser }) => {
            if (user)
                localStorage.setItem('currentuser', JSON.stringify(user));
            if (respondUser)
                localStorage.setItem('responduser', JSON.stringify(respondUser));
        }),
        // filter(({ user }) => !!user),
        // map(({ user }) => user),
        // mergeMap(user => this.permissionService.GetUserPermission(user.UserAccountID).pipe(
        //     map(permissions => userActions.userPermissionsUpdated({ permissions })),
        //     catchError(e => of(userActions.userPermissionsNotLoaded()))
        // ))
    ), { dispatch: false });

    loggedOut$ = createEffect(() => this.action$.pipe(
        ofType(userActions.userLoggedOut),
        tap(() => {
            localStorage.clear();
        })
    ),
        { dispatch: false });

    emulatedUser$ = createEffect(() => this.action$.pipe(
        ofType(userActions.userEmulationStarted),
        mergeMap(({ emulatedUser }) => this.permissionService.GetUserPermission(emulatedUser.UserAccountID).pipe(
            map(permissions => userActions.userPermissionsUpdated({ permissions })),
            catchError(e => of(userActions.userPermissionsNotLoaded()))
        ))));

    // Load feature catalog & user features after a successful login (non-respond user)
    loadFeaturesOnLogin$ = createEffect(() => this.action$.pipe(
        ofType(userActions.userLoggedIn),
        filter(({ user }) => !!user),
        withLatestFrom(this.store.select(featureSelectors.allFeatures)),
        mergeMap(([{ user }, allFeatures]) => {
            const actions: Action[] = [];
            if (!allFeatures || allFeatures.length === 0) {
                actions.push(featureActions.loadAllFeatures());
            }
            if (user && user.UserAccountID) {
                actions.push(featureActions.loadUserFeatures({ userId: user.UserAccountID }));
            }
            return actions;
        })
    ));

    // Capture current user's feature ids into user slice when their features are loaded or updated
    captureCurrentUserFeatures$ = createEffect(() => this.action$.pipe(
        ofType(featureActions.loadUserFeaturesSuccess, featureActions.updateUserFeaturesSuccess),
        withLatestFrom(this.store.select(userSelectors.currentUser)),
        filter(([action, currentUser]) => !!currentUser && !!action && 'userId' in action && action.userId === (currentUser!.UserAccountID || currentUser!.UserAccountId)),
        map(([action]) => userActions.currentUserFeaturesUpdated({ featureIds: action.featureIds }))
    ));
}